import * as React from "react";
import {
    Fragment,
} from "react";
import { Grid } from "@mui/material";
import { Outlet } from "react-router-dom";
import { settingStyles } from "./setting";

const SettingLayout = () => {
    const { classes } = settingStyles()
    const {
        mainblock,
        heading,
        outletCtn
    } = classes;

    return (
        <Fragment>
            <Grid container direction="column" className={mainblock}>
                <Grid className={heading} item>
                    Settings
                </Grid>
                <Grid item className={outletCtn}>
                    <Outlet />
                </Grid>
            </Grid>
        </Fragment>
    );
};

export default SettingLayout